// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProgressBar.css */
.progress-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
    background: #26E752;
    background: linear-gradient(179deg, rgb(30, 177, 64) 19%, rgba(54, 66, 55, 0.87) 85%);
    border-radius: 12px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    color: white;
    font-family: 'Segoe UI', sans-serif;
    transition: all 0.3s ease;
}

.items-start {
    color: #24292e;
}


.progress-title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 8px;
}

.buttonItem {
    border-radius: 25px;
    color: white;
    padding: 5px 30px 5px 30px;
    margin-top: 10px;
    margin-left: 15px;
    font-size: 20px;
}

.buttonItemSuggest {
    background: linear-gradient(180deg, rgba(0, 105, 24, 1) 40%, rgba(31, 153, 71, 1) 94%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#006918", endColorstr="#1F9947", GradientType=0);
}

.buttonItemRun {
    background: #db0909;
    background: linear-gradient(180deg, rgba(219, 9, 9, 1) 40%, rgba(120, 49, 11, 1) 94%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#DB0909",
            endColorstr="#78310B",
            GradientType=0);
}

.progress-percentage {
    font-size: 35px;
    font-weight: 700;
    margin-bottom: 12px;
    color: #24292e;
}

.progress-bar-wrapper {
    width: 100%;
    height: 16px;
    background-color: #34495e;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
}

.progress-fill {
    height: 100%;
    border-radius: 6px;
    transition: width 0.1s ease-out;
    position: relative;
    overflow: hidden;
}

.progress-fill::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg,
            rgba(255, 255, 255, 0.1),
            rgba(255, 255, 255, 0.3),
            rgba(255, 255, 255, 0.1));
    animation: progressAnimation 2s infinite;
}

.progress-fill.over-50 {
    background: linear-gradient(90deg, #2ecc71, #27ae60);
}

.progress-fill.under-50 {
    background: linear-gradient(90deg, #e74c3c, #c0392b);
}

@keyframes progressAnimation {
    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(100%);
    }
}

@keyframes shine {
    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(100%);
    }
}

.animate-shine {
    animation: shine 2s infinite;
}

/* Animation nhấp nháy số % */
@keyframes pulseText {
    0%, 100% {
      color: #ff0000;
      text-shadow: 
        0 0 5px #fbbf24,
        0 0 10px rgba(255, 183, 2, 0.8),
        0 0 20px rgba(255, 183, 2, 0.6);
      /* transform: scale(1); */
    }
    
    25%, 75% {
      color: #ff3333;
      text-shadow: 
        0 0 15px #fbbf24,
        0 0 30px rgba(255, 183, 2, 0.9),
        0 0 45px rgba(255, 255, 255, 0.7);
      /* transform: scale(1.02); */
    }
    
    50% {
      color: #ff0000;
      text-shadow: 
        0 0 25px #fbbf24,
        0 0 50px rgba(255, 183, 2, 1),
        0 0 75px rgba(255, 255, 255, 0.9);
      /* transform: scale(1.05); */
    }
  }
.animate-pulse-text {
    animation: pulseText 0.8s infinite cubic-bezier(0.4, 0, 0.6, 1);
    will-change: transform, color, text-shadow;
  }

@keyframes pulseGlow {

    0%,
    100% {
        box-shadow: 0 0 5px rgba(239, 68, 68, 0.5);
    }

    50% {
        box-shadow: 0 0 15px rgba(239, 68, 68, 0.8);
    }
}

.animate-pulse-glow {
    animation: pulseGlow 1s infinite;
}

@keyframes imageWobble {
    0% {
        transform: scale3d(1, 1, 1) rotate(0deg);
        filter: drop-shadow(0px 0px 15px rgba(0, 53, 13, 0.8));
    }

    15% {
        transform: scale3d(1.08, 1.08, 1.08) rotate(6deg);
        filter: drop-shadow(0px 0px 20px rgba(0, 255, 64, 0.6));
    }

    30% {
        transform: scale3d(1.12, 1.12, 1.12) rotate(-6deg);
        filter: drop-shadow(0px 0px 25px rgba(0, 255, 64, 0.8));
    }

    45% {
        transform: scale3d(1.12, 1.12, 1.12) rotate(6deg);
    }

    60% {
        transform: scale3d(1.12, 1.12, 1.12) rotate(-6deg);
    }

    75% {
        transform: scale3d(1.12, 1.12, 1.12) rotate(6deg);
    }

    85% {
        transform: scale3d(1.05, 1.05, 1.05) rotate(0deg);
        filter: drop-shadow(0px 0px 20px rgba(0, 53, 13, 0.9));
    }

    100% {
        transform: scale3d(1, 1, 1) rotate(0deg);
        filter: drop-shadow(0px 0px 15px rgba(0, 53, 13, 0.8));
    }
}

.game-image {
    width: 160px;
    height: 160px;
    object-fit: cover;
    /* border-radius: 50%; */
    margin-bottom: 12px;
    filter: drop-shadow(0px 0px 25px black);
}

.game-image-animation {
    animation: imageWobble 1.2s infinite;
    will-change: transform, filter;
}`, "",{"version":3,"sources":["webpack://./src/pages/NH/components/ProgressBar.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,qFAAqF;IACrF,mBAAmB;IACnB,yCAAyC;IACzC,YAAY;IACZ,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IAGI,sFAAsF;IACtF,kHAAkH;AACtH;;AAEA;IACI,mBAAmB;IAGnB,qFAAqF;IACrF;;2BAEuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;;;qCAGiC;IACjC,wCAAwC;AAC5C;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA,6BAA6B;AAC7B;IACI;MACE,cAAc;MACd;;;uCAGiC;MACjC,yBAAyB;IAC3B;;IAEA;MACE,cAAc;MACd;;;yCAGmC;MACnC,4BAA4B;IAC9B;;IAEA;MACE,cAAc;MACd;;;yCAGmC;MACnC,4BAA4B;IAC9B;EACF;AACF;IACI,+DAA+D;IAC/D,0CAA0C;EAC5C;;AAEF;;IAEI;;QAEI,0CAA0C;IAC9C;;IAEA;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI;QACI,wCAAwC;QACxC,sDAAsD;IAC1D;;IAEA;QACI,iDAAiD;QACjD,uDAAuD;IAC3D;;IAEA;QACI,kDAAkD;QAClD,uDAAuD;IAC3D;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,kDAAkD;IACtD;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,iDAAiD;QACjD,sDAAsD;IAC1D;;IAEA;QACI,wCAAwC;QACxC,sDAAsD;IAC1D;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;AAClC","sourcesContent":["/* ProgressBar.css */\n.progress-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: auto;\n    background: #26E752;\n    background: linear-gradient(179deg, rgb(30, 177, 64) 19%, rgba(54, 66, 55, 0.87) 85%);\n    border-radius: 12px;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n    color: white;\n    font-family: 'Segoe UI', sans-serif;\n    transition: all 0.3s ease;\n}\n\n.items-start {\n    color: #24292e;\n}\n\n\n.progress-title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    text-align: center;\n    margin-bottom: 8px;\n}\n\n.buttonItem {\n    border-radius: 25px;\n    color: white;\n    padding: 5px 30px 5px 30px;\n    margin-top: 10px;\n    margin-left: 15px;\n    font-size: 20px;\n}\n\n.buttonItemSuggest {\n    background: -webkit-linear-gradient(180deg, rgba(0, 105, 24, 1) 40%, rgba(31, 153, 71, 1) 94%);\n    background: -moz-linear-gradient(180deg, rgba(0, 105, 24, 1) 40%, rgba(31, 153, 71, 1) 94%);\n    background: linear-gradient(180deg, rgba(0, 105, 24, 1) 40%, rgba(31, 153, 71, 1) 94%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#006918\", endColorstr=\"#1F9947\", GradientType=0);\n}\n\n.buttonItemRun {\n    background: #db0909;\n    background: -webkit-linear-gradient(180deg, rgba(219, 9, 9, 1) 40%, rgba(120, 49, 11, 1) 94%);\n    background: -moz-linear-gradient(180deg, rgba(219, 9, 9, 1) 40%, rgba(120, 49, 11, 1) 94%);\n    background: linear-gradient(180deg, rgba(219, 9, 9, 1) 40%, rgba(120, 49, 11, 1) 94%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#DB0909\",\n            endColorstr=\"#78310B\",\n            GradientType=0);\n}\n\n.progress-percentage {\n    font-size: 35px;\n    font-weight: 700;\n    margin-bottom: 12px;\n    color: #24292e;\n}\n\n.progress-bar-wrapper {\n    width: 100%;\n    height: 16px;\n    background-color: #34495e;\n    border-radius: 6px;\n    overflow: hidden;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.progress-fill {\n    height: 100%;\n    border-radius: 6px;\n    transition: width 0.1s ease-out;\n    position: relative;\n    overflow: hidden;\n}\n\n.progress-fill::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(90deg,\n            rgba(255, 255, 255, 0.1),\n            rgba(255, 255, 255, 0.3),\n            rgba(255, 255, 255, 0.1));\n    animation: progressAnimation 2s infinite;\n}\n\n.progress-fill.over-50 {\n    background: linear-gradient(90deg, #2ecc71, #27ae60);\n}\n\n.progress-fill.under-50 {\n    background: linear-gradient(90deg, #e74c3c, #c0392b);\n}\n\n@keyframes progressAnimation {\n    from {\n        transform: translateX(-100%);\n    }\n\n    to {\n        transform: translateX(100%);\n    }\n}\n\n@keyframes shine {\n    from {\n        transform: translateX(-100%);\n    }\n\n    to {\n        transform: translateX(100%);\n    }\n}\n\n.animate-shine {\n    animation: shine 2s infinite;\n}\n\n/* Animation nhấp nháy số % */\n@keyframes pulseText {\n    0%, 100% {\n      color: #ff0000;\n      text-shadow: \n        0 0 5px #fbbf24,\n        0 0 10px rgba(255, 183, 2, 0.8),\n        0 0 20px rgba(255, 183, 2, 0.6);\n      /* transform: scale(1); */\n    }\n    \n    25%, 75% {\n      color: #ff3333;\n      text-shadow: \n        0 0 15px #fbbf24,\n        0 0 30px rgba(255, 183, 2, 0.9),\n        0 0 45px rgba(255, 255, 255, 0.7);\n      /* transform: scale(1.02); */\n    }\n    \n    50% {\n      color: #ff0000;\n      text-shadow: \n        0 0 25px #fbbf24,\n        0 0 50px rgba(255, 183, 2, 1),\n        0 0 75px rgba(255, 255, 255, 0.9);\n      /* transform: scale(1.05); */\n    }\n  }\n.animate-pulse-text {\n    animation: pulseText 0.8s infinite cubic-bezier(0.4, 0, 0.6, 1);\n    will-change: transform, color, text-shadow;\n  }\n\n@keyframes pulseGlow {\n\n    0%,\n    100% {\n        box-shadow: 0 0 5px rgba(239, 68, 68, 0.5);\n    }\n\n    50% {\n        box-shadow: 0 0 15px rgba(239, 68, 68, 0.8);\n    }\n}\n\n.animate-pulse-glow {\n    animation: pulseGlow 1s infinite;\n}\n\n@keyframes imageWobble {\n    0% {\n        transform: scale3d(1, 1, 1) rotate(0deg);\n        filter: drop-shadow(0px 0px 15px rgba(0, 53, 13, 0.8));\n    }\n\n    15% {\n        transform: scale3d(1.08, 1.08, 1.08) rotate(6deg);\n        filter: drop-shadow(0px 0px 20px rgba(0, 255, 64, 0.6));\n    }\n\n    30% {\n        transform: scale3d(1.12, 1.12, 1.12) rotate(-6deg);\n        filter: drop-shadow(0px 0px 25px rgba(0, 255, 64, 0.8));\n    }\n\n    45% {\n        transform: scale3d(1.12, 1.12, 1.12) rotate(6deg);\n    }\n\n    60% {\n        transform: scale3d(1.12, 1.12, 1.12) rotate(-6deg);\n    }\n\n    75% {\n        transform: scale3d(1.12, 1.12, 1.12) rotate(6deg);\n    }\n\n    85% {\n        transform: scale3d(1.05, 1.05, 1.05) rotate(0deg);\n        filter: drop-shadow(0px 0px 20px rgba(0, 53, 13, 0.9));\n    }\n\n    100% {\n        transform: scale3d(1, 1, 1) rotate(0deg);\n        filter: drop-shadow(0px 0px 15px rgba(0, 53, 13, 0.8));\n    }\n}\n\n.game-image {\n    width: 160px;\n    height: 160px;\n    object-fit: cover;\n    /* border-radius: 50%; */\n    margin-bottom: 12px;\n    filter: drop-shadow(0px 0px 25px black);\n}\n\n.game-image-animation {\n    animation: imageWobble 1.2s infinite;\n    will-change: transform, filter;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
